module.exports = __webpack_public_path__ + "assets/img/img-4.55f0fff4.png";